// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__TSgVe","resendInfoText":"OnGoingPaymentBox_resendInfoText__3hT0w"};